/* istanbul ignore file */
import React from 'react';
import { RadioButtonGroup, RadioButtonGroupProps } from 'framework/form';

const MARITAL_STATUSES = [
  { label: 'Single', value: 'NOT_MARRIED' },
  { label: 'Married', value: 'MARRIED' },
];

const MaritalStatusInput = (props: RadioButtonGroupProps) => {
  return <RadioButtonGroup options={MARITAL_STATUSES} {...props} />;
};

export default MaritalStatusInput;
